import { render } from "./realNameVerify.vue?vue&type=template&id=730be1ea&scoped=true"
import script from "./realNameVerify.vue?vue&type=script&lang=js"
export * from "./realNameVerify.vue?vue&type=script&lang=js"

import "./realNameVerify.vue?vue&type=style&index=0&id=730be1ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730be1ea"]])

export default __exports__